import { zIndex } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

/**
 * Workaround for the hardcoded z-index in the Lumen Dialog component: it portals to
 * document.body without enough z-index to sit above Billy overlays (Dropdown, Modal).
 */
export const lumenDialogStackingFix = css`
  [class^='_backdrop_'],
  [class*=' _backdrop_'] {
    z-index: ${zIndex.Modal} !important;
  }
`

/*
  The Lumen Dialog panel has no max-height and its body does not scroll, so an expanded
  form pushes the action buttons past the viewport. Capping the form keeps them reachable.
  The subtracted height covers the dialog padding, header, action row and their gaps.
*/
export const CreateSupplierModalScrollArea = styled.div`
  width: 100%;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
`
